import { yupResolver } from "@hookform/resolvers/yup"
import React, { useState, useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Spinner,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import { UFInput } from "../../../components/Common/Fields/Input"
import classnames from "classnames"
import closeIcon from "../../../assets/icons/close.svg"
import { Link } from "react-router-dom"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { postFinanceCostCenter } from "../../../services/finance/finance"
import CostCategoryLi from "../../../components/Common/chooseFields/costCenterCat"
import FinCostCenterLi from "../../../components/Common/chooseFields/costCenterFinLi"

const schema = yup.object().shape({
  name: yup.string().required("Account Name is Required"),
})

const Edit = ({ loading, onUpdate, id, error, close, ...props }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
      cost_category_id: { label: "Primary", value: "1" },
      under_id: { label: "Primary", value: "1" },
      used_for_job_costing: false,
    },
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [jobCost, setJobCost] = useState(false)

  useEffect(() => {
    if (props?.editItem?.modal) {
      console.log(
        `props?.editItem?.value?.parent`,
        props?.editItem?.value?.parent
      )

      reset({
        ...props?.editItem?.value,
        cost_category_id: props?.editItem?.value?.cost_category?.id ? {
          label: props?.editItem?.value?.cost_category?.name,
          value: props?.editItem?.value?.cost_category?.id,
        } : null,
        under_id: props?.editItem?.value?.parent?.id ? {
          label: props?.editItem?.value?.parent?.name,
          value: props?.editItem?.value?.parent?.id,
        } : null,
      })
      setJobCost(props?.editItem?.value?.used_for_job_costing)
    }
  }, [props?.editItem?.modal])

  const handleUseJobCheck = dt => {
    setJobCost(!dt)
  }

  const handleRegistration = async data => {
    console.log(`regist---`, data)

    try {
      setIsLoading(true)
      const createdSeries = await postFinanceCostCenter({
        ...data,
        name: data?.name,
        description: "",
        used_for_job_costing: jobCost ? 1 : 0,
        cost_category_id: data?.cost_category_id?.value,
        under_id: data?.under_id?.value,
      })
      toastSuccess(createdSeries?.message)
      onUpdate && onUpdate(createdSeries?.data)
      close()
      reset()
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <ModalHeader className="custom-modal-header">
        <div className="d-flex justify-content-between">
          <h5>
            {props?.editItem?.modal ? "Edit Cost Center" : "New Cost Center"}
          </h5>{" "}
          <img
            src={closeIcon}
            alt=""
            onClick={close}
            width="10"
            role="button"
          />
        </div>
      </ModalHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="lg"
          />
        </div>
      ) : (
        <>
          <ModalBody>
            <FormProvider {...methods}>
              <Form id={`ev-form`} onSubmit={handleSubmit(handleRegistration)}>
                <Row>
                  <Col lg={12}>
                    <FormGroup className="mb-4">
                      <Label>Cost Category</Label>
                      <CostCategoryLi
                        control={control}
                        placeholder="Enter the Name"
                        name={"cost_category_id"}
                        invalid={!!errors.cost_category_id}
                      />
                      <FormFeedback invalid>
                        {errors.cost_category_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col lg={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Name<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Name"
                        name={"name"}
                        invalid={!!errors.name}
                      />
                      <FormFeedback invalid>
                        {errors.name?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col lg={12}>
                    <FormGroup className="mb-4">
                      <Label>Under</Label>
                      <FinCostCenterLi
                        control={control}
                        placeholder="Select"
                        name={"under_id"}
                        invalid={!!errors.under_id}
                      />
                      <FormFeedback invalid>
                        {errors.under_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col
                    lg={"auto"}
                    onClick={() => handleUseJobCheck(jobCost)}
                    className="mt-auto"
                  >
                    <FormGroup className="mt-2">
                      <input
                        type="checkbox"
                        className="ever-rise-checkbox"
                        name={"used_for_job_costing"}
                        checked={jobCost}
                      />
                      <Label className="ms-2">Used for Job Costing</Label>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </ModalBody>
          <ModalFooter>
            <LoadingButton
              form={`ev-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {props?.editItem?.modal ? "Update" : "Save"}
            </LoadingButton>
          </ModalFooter>
        </>
      )}
    </>
  )
}

const EditCostCenterFinance = ({ buttonLabel, className, ...props }) => {
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  useEffect(() => {
    if (props?.editItem?.modal) {
      toggle()
    }
  }, [props?.editItem?.modal])
  useEffect(() => {
    if (props?.show) {
      setModal(true)
    }
  }, [props?.show])

  return (
    <>
      <Link to="#" className={className} onClick={toggle}>
        {buttonLabel}
      </Link>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <Edit
          close={() => {
            setModal(false)
            props?.onReset()
          }}
          {...props}
        />
      </Modal>
    </>
  )
}

export default EditCostCenterFinance
